/* eslint-disable react/prop-types */
/* eslint-disable react/function-component-definition */

import React, { useState } from "react";
// @mui material components
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";

// Material Dashboard 2 React context
import { useMaterialUIController } from "context";
import apiClient from "../../../../../apiClient";

function AddRoomType({ onClose, onSuccess, onFailed, editFormData }) {
  const [controller] = useMaterialUIController();
  const { darkMode } = controller;
  const [editData, setEditData] = useState(editFormData);

  const [formData, setFormData] = useState({
    name: editData ? editData.name : "",
    status: editData.status || "Active",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    // Handle form submission logic here
    const isEdit = editData && Object.keys(editData).length > 0; // Check if editData exists
    try {
      const endpoint = isEdit ? `/admin/room-type/update/${editData._id}` : "/admin/room-type"; // Use ID for PUT
      const method = isEdit ? apiClient.put : apiClient.post; // PUT for edit, POST for create

      // Make the API request
      const response = await method(endpoint, formData);
      if (response.status === 200) {
        if (response.data.status === "success") {
          onSuccess();
          onClose();
        } else if (response.data.status === "false") {
          console.error("Error creating room type:", response.data.message);
          // showing failed message in snackbar
          onFailed(response.data.message);
          onClose();
        }
      }
    } catch (error) {
      console.error("Error creating room type:", error);
    }
  };

  return (
    <Card id="add-coupons">
      <MDBox p={4}>
        <form onSubmit={handleSubmit}>
          <Grid container spacing={3} lg={12}>
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Room Type"
                name="name"
                value={formData.name}
                onChange={handleChange}
                required
              />
            </Grid>
            <Grid item xs={12}>
              <Select
                fullWidth
                label="Status"
                name="status"
                value={formData.status}
                onChange={handleChange}
                sx={{ height: "40px" }}
              >
                <MenuItem value="Active">Active</MenuItem>
                <MenuItem value="Inactive">Inactive</MenuItem>
              </Select>
            </Grid>
            <Grid item xs={12}>
              <Button
                type="submit"
                variant="contained"
                color="primary"
                fullWidth
                sx={{ color: "#fff" }}
              >
                Submit
              </Button>
            </Grid>
          </Grid>
        </form>
      </MDBox>
    </Card>
  );
}

export default AddRoomType;
